<template>
  <v-app>
    <splash></splash>
    <layout-navbar></layout-navbar>
    <layout-sidenav></layout-sidenav>
    <v-main class="fixed-padding" :style="isCustomDashboard ? 'background-color: #f6f5f5' : 'background-color: white'">

        <!-- Wrap router view in a relative positioned container for the overlay -->
        <div class="router-view-container">
          <!-- TODO: Find a better solution to handle navigation without refreshing the view (:key="$route.fullPath") -->
          <router-view></router-view>
          
          <!-- Loading overlay for route resolvers -->
          <loading-overlay ref="loadingOverlay" />
        </div>

        <alert-component :data="nomenclatorAlert" />

        <!--<DrawerCustomizer />-->

    </v-main>
    <DataWS :userid="(profile.id).toString()" />
  </v-app>
</template>

<script>
  import LayoutNavbar from '@/components/layout/LayoutNavbar'
  import LayoutSidenav from '@/components/layout/LayoutSidenav'
  import AlertComponent from '@/components/AlertComponent'
  import DataWS from '@/module/configuration/notifications/components/DataWS'
  import DrawerCustomizer from "@customization/components/DrawerCustomizer.vue"
  import Splash from "@/components/Splash.vue"
  import LoadingOverlay from "@/components/LoadingOverlay.vue"
  import {mapGetters} from 'vuex';

  export default {
    components: {
      Splash,
      DrawerCustomizer,
      DataWS,
      AlertComponent,
      LayoutNavbar,
      LayoutSidenav,
      LoadingOverlay
    },

    data: () => ({
      primaryDrawer: {
        model: null,
      },
      profile: null
    }),

    created() {
      this.profile = JSON.parse(localStorage.getItem("profile"))
    },
    
    mounted() {
      // Listen to resolver events for debugging
      import('@/router/route-resolvers').then(({ resolverEvents }) => {
        resolverEvents.$on('resolver:start', ({ routeName }) => {
          console.log('Default.vue: resolver:start event received for', routeName);
        });
        
        resolverEvents.$on('resolver:end', ({ routeName }) => {
          console.log('Default.vue: resolver:end event received for', routeName);
        });
      });
    },

    computed: {
      ...mapGetters({
        loadInitData: "general/loading",
      }),
      isCustomDashboard() {
        console.log(this.$route.path)
        return this.$route.path === '/custom/dashboard'
      },
      nomenclatorAlert: {
        get() {
          return this.$store.getters['ui/GET_NOMENCLATOR_DATA']
        },
        set(val) {
          this.$store.commit('ui/NOMENCLATOR_DATA', val)
        },
      },
    }
  }
</script>

<style scoped>
.fixed-padding {
  padding: 64px 0px 0px 256px;

  @media only screen and (min-width: 768px) {
    padding: 64px 0 0 64px;
  }
}

.router-view-container {
  position: relative;
  min-height: 80vh; /* Ensure there's enough space for the loading overlay */
}
</style>
